export default __webpack_public_path__ + "assets/images/75f672071517be35fb9be09304a1895a.png";